import moment from "moment-timezone";


// Return list of the Date Period
// Example:
//   2024-09-01 ~ 2025-08-31 --> 24
//
export const getDatePeriodOptions = (yearToList=5, startMonth = 9) => {

    const now = moment();
    const zone = "Asia/Hong_Kong";
    const hkTime = now.tz(zone);
    const currentYear = hkTime.year();


    // const hkMonth = hkTime.month() + 1; // month is 0-based
    if (startMonth == 1) {    // 1月 

        let options = [];
        for (let i = 0; i < yearToList; i++) {
            const year = currentYear - i;
            const startDate = moment([year, 0, 1]); // January 1st
            const endDate = moment([year, 11, 31]); // December 31st
            const label = `${year} 年度`;

            // getting the local date string in YYYY-MM-DD format
            const startDateStr = startDate.format("YYYY-MM-DD");
            const endDateStr = endDate.format("YYYY-MM-DD");

            const dateRangeStr = `${startDateStr} ~ ${endDateStr}`;
            // console.debug("dateRange: ", dateRange);

            options.push({ label: label, value: year, range: dateRangeStr });
        }

        return options;
    }



    let options = [];
    for (let i = 0; i < yearToList; i++) {
        const year = currentYear - i;
        const label = `${year}/${year + 1} 學年`;

        const startDate = moment([year, startMonth - 1, 1]); // startMonth is 1-based, moment month is 0-based
        const endDate = moment(startDate).add(1, 'year').subtract(1, 'day'); // Add 1 year and subtract 1 day

        // Get the UTC+8 (HKT) date string in YYYY-MM-DD format
        const startDateStr = startDate.tz(zone).format("YYYY-MM-DD");
        const endDateStr = endDate.tz(zone).format("YYYY-MM-DD");

        console.debug("startDateStr, endDateStr: ", startDateStr, endDateStr);

        const dateRangeStr = `${startDateStr} ~ ${endDateStr}`;
        console.debug("dateRange: ", dateRangeStr);

        options.push({ label: label, value: year, range: dateRangeStr });
    }

    return options;
};

export const getCurrentPeriodYear = (startMonth = 9) => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    if (month >= startMonth) {
        return year;
    }
    return year - 1;
}

